module.exports = __webpack_public_path__ + "img/collection-diamondJewelryCollectionRings.014ef37.jpg";